import React from 'react';
import './Hero.css';
import Buttons from '../Buttons/Buttons';

const Hero = () => {
  return (
    <section className="hero">
    </section>
  );
};

export default Hero;
